export default "__VITE_ASSET__3734fe7d__"